/**
 * enterpriseWechatRobot模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const enterpriseWechatRobot = {
  //新增编辑企业微信机器人
  createOrUpdate(params) {
    return $http.post(`${global.API_URL}/sme/enterpriseWechatRobot/createOrUpdate`,params);
  },
  //删除企业微信机器人
  delete(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/enterpriseWechatRobot/delete`,param);
  },
  //分页查询
  pagingQuery(params) {
    return $http.post(`${global.API_URL}/sme/enterpriseWechatRobot/pagingQuery`,params);
  },
  //根据id查询机器人详情
  getEnterpriseWechatRobotInfoById(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/enterpriseWechatRobot/getEnterpriseWechatRobotInfoById`,param);
  },
  //根据监控模块查询关联的机器人列表
  listEnterpriseWechatRobotsByMonitorModule(params) {
    return $http.post(`${global.API_URL}/sme/enterpriseWechatRobot/listEnterpriseWechatRobotsByMonitorModule`,params);
  }
}

export default enterpriseWechatRobot;



// WEBPACK FOOTER //
// ./src/api/enterpriseWechatRobot.js